// extracted by mini-css-extract-plugin
module.exports = {"component":"BananaValue_component__1EddY","token":"BananaValue_token__14kk2"};